import { Container, Paper, Stack, Switch, Text, Title } from '@mantine/core';
import { useState } from 'react';
import {
  readShowLocalhostOnlyUi,
  writeShowLocalhostOnlyUi,
} from '../../../config/featureVisibility';

/**
 * Local Vite-only control. Stays visible when localhost-only UI is toggled off
 * so you can turn the preview back on.
 */
export function LocalhostPreviewSettings(): JSX.Element {
  const [showLocalhostOnlyUi, setShowLocalhostOnlyUi] = useState(readShowLocalhostOnlyUi);

  const handleToggle = (checked: boolean): void => {
    setShowLocalhostOnlyUi(checked);
    writeShowLocalhostOnlyUi(checked);
    globalThis.location.reload();
  };

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        <div>
          <Title order={2} mb="xs">
            Localhost preview
          </Title>
          <Text size="sm" c="dimmed">
            This page is only available on the local Vite dev server. Use it to hide
            localhost-only screens and controls so the app matches Dev and Prod.
          </Text>
        </div>

        <Paper p="xl" withBorder>
          <Switch
            label="Show localhost-only screens and controls"
            description="When off, localhost-only nav, pages, badges, and extra controls are hidden. The page reloads after you change this."
            checked={showLocalhostOnlyUi}
            onChange={(event) => handleToggle(event.currentTarget.checked)}
          />
        </Paper>
      </Stack>
    </Container>
  );
}
